import CityPageTemplate from "../city-template/CityPageTemplate";
import { killeenConfig } from "./data";

export default function KilleenPage() {
  return <CityPageTemplate config={killeenConfig} />;
}